/* eslint-disable max-len */
export const dictionary = {
  Loading: 'Loading',
  'Policy and Privacy Terms': 'Policy and Privacy Terms',
  'Terms of Use': 'Terms of Use',
  PrivacyPolicy: 'Privacy policy',
  'Game Journey': 'Game Journey',
  'I agree with': 'I agree with',
  "Engagers Game's": "Engagers Game's",
  'Enter here': 'Enter here',
  'Register below': 'Register below',
  'Register here': 'Register here',
  'Click here': 'Click here',
  Close: 'Close',
  'Enter your password to continue': 'Enter your password to continue',
  'Wrong password': 'Wrong password',
  'Start the mission here': 'Start the mission here',
  'Follow the score here': 'Follow the score here',
  'The time will appear centered when starting the mission': 'The time will appear centered when starting the mission',
  'Enlarge the image if necessary': 'Enlarge the image if necessary',
  'Send photo': 'Send photo',
  'Drag or paste your photo here': 'Drag or paste your photo here',
  'Choose photo': 'Choose photo',
  'Photo caption': 'Photo caption',
  'Select below': 'Select below',
  'alternative(s)': 'alternative(s)',
  Blocked: 'Blocked',
  Done: 'Done',
  'See missions': 'See missions',
  Gallery: 'Gallery',
  Instructions: 'Instructions',
  Points: 'Points',
  'Recovery game': 'Recovery game',
  PhotoMission: 'Photo Mission',
  'Audio: on/off': 'Audio: on/off',
  "Your browser don't support HTML5": "Your browser don't support HTML5",
  "Couldn't load instructions": "Couldn't load instructions",
  Team: 'Team',
  Mission: 'Mission',
  PhotoMissionInstructionOne: 'Click on camera button to upload the photo.',
  PhotoMissionInstructionTwo: 'If you want, write a caption for the photo in the box below the uploaded image.',
  PhotoMissionInstructionThree: 'Click the button on the bottom right corner of the screen to complete the mission.',
  PhotoMissionInstructionDesktop: 'Drag imagens or paste screenshots into the larger input.',
  TeamName: 'Team Name',
  OpenAnswer: 'Open Answer',
  OpenAnswerInstructionOne: 'Enter your answer in the box labeled “Enter here...” and then click the button on the bottom right corner to send your answer.',
  ConnectDots: 'Connect the dots',
  ConnectDotsInstructionOne: 'Select with one click the option in column (A) and then select in column (B) which option it connects.',
  SimpleText: 'Simple Text',
  SimpleTextInstructionOne: 'After reading the screen, click the button on the bottom right corner to continue.',
  MultipleChoice: 'Multiple Choice',
  MultipleChoiceInstructionOne: 'Click on the arrow in the right corner of the bar to see the full text of the alternative, when there are.',
  MultipleChoiceInstructionTwo: 'Click on the bar with the alternative you want to select.',
  MultipleChoiceInstructionThree: 'To send the answer, click on the button in the bottom right corner.',

  Welcome: 'Welcome!',
  'Login to access the game': 'Login to access the game',
  'Sign in with Google': 'Sign in with Google',
  Password: 'Password',
  'Enter with your E-mail': 'Enter with your E-mail',
  'Enter with the password': 'Enter with the password',
  Access: 'Access',
  'Forgot your password?': 'Forgot your password?',
  'Need help?': 'Need help?',
  'E-mail is required': 'E-mail is required',
  'E-mail is invalid': 'E-mail is invalid',
  'Password is required': 'Password is required',
  'Password must have 8 characters at least': 'Password should have 8 characters at least',
  'Password must have 1 number at least': 'Password should have 1 number at least',
  'Password must have 1 lowercase letter at least': 'Password should have 1 lowercase letter at least',
  'Password must have 1 uppercase letter at least': 'Password should have 1 uppercase letter at least',
  'Password must have 1 special character at least': 'Password should have 1 special character at least',
  'New Password': 'New Password',
  'Changing...': 'Changing...',
  Change: 'Change',
  'Change your name': 'Change your name',
  'Change your password': 'Change your password',
  'Tell us what would you like to be called?': 'Tell us what would you like to be called? This name will be linked to your answers on Feed. ',
  'Your name': 'Your name',
  "Your game hasn't started yet.": "Your game hasn't started yet.",
  'Your game is now finished.': 'Your game is now finished.',
  'There is no game for you yet.': 'There is no game for you yet.',
  Finish: 'All ready with the game',
  'Start playing': 'Start playing',
  'As this is your first access, you must change your password for your best security!': 'As this is your first access, you must change your password for your best security!',
  PasswordRules: 'Your password must have at least <span>8 characters</span> with at least <span>1 lowercase letter</span>, <span>1 uppercase letter</span>, <span>1 number</span> and <span>1 special character</span>',
  'No missions until now': 'No missions until now',
  'Good! You finished all available missions!': 'Good! You finished all available missions!',
  'These are your missions for today:': 'These are your missions for today:',
  'Finished missions': 'Completed Missions',
  'Allowed missions': 'Available Missions',
  Home: 'Home',
  More: 'More',
  'Change Password': 'Change Password',
  'Current Password': 'Current Password',
  'Confirm New Password': 'Confirm New Password',
  Save: 'Save',
  Saving: 'Saving',
  'Password updated successfully!': 'Password updated successfully!',
  'Sign Out': 'Sign Out',
  'Do you really want to sign out?': 'Do you really want to sign out?',
  Yes: 'Yes',
  No: 'No',
  'Recovery Password': 'Recovery Password',
  Code: 'Code',
  'Enter the code': 'Enter the code',
  'Send code': 'Send code',
  Sending: 'Sending',
  'Enter the new password': 'Enter the new password',
  'Confirm the new password': 'Confirm the new password',
  'Password recovered successfully!': 'Password recovered successfully!',
  'Try again': 'Try again',
  'Send us a message': 'Send us a message',
  Name: 'Name',
  Game: 'Game',
  Message: 'Message',
  Send: 'Send',
  'Your message was sent. We will reply to you by e-mail shortly.': 'Sua mensagem foi enviada. Em breve responderemos você por e-mail.',
  Document: 'Document',
  ForgotPasswordSuccess: 'Recovery data has been sent to your email. Check and login.',
  'Go to Login': 'Go to Login',

  AlertSendAnswer: 'Error on sending your answer. Try again later.',

  ValidateMinName: 'At least 2 characters',
  ValidatePasswordNotEquals: "Passwords aren't the same",
  ValidateOnlyNumbers: 'Only numbers',

  ERROR_ACCESS_DENIED: 'Access denied.',
  ERROR_UNEXPECTED: 'Unexpected error.',
  ERROR_NO_AUTHORIZATION: 'No authorization.',
  ERROR_DATA_NOT_FOUND: 'Data not found',
  INFO_DATA_NOT_FOUND: 'Access the Game again or contact support.',
  "You don't have permission to access this page.": "You don't have permission to access this page.",
  ERROR_GAME_NOT_FOUND: 'Hi, let´s start again. ',
  INFO_GAME_NOT_FOUND: 'Please, scan the QR CODE or access the link again.',
  PASS_REQUIREMENTS: 'Your password must have at least: 8 characters, including 1 number, 1 uppercase letter, and 1 special character.',
  NetworkError: 'Network error',
  APPROVAL_MODE_INSTRUCTIONS: 'Hi, you received this game to approve!',
  ATTEMPTS_TRIGGER_NAME: 'Attempts Trigger',
  CORRECT_ANSWER_TRIGGER_NAME: 'Correct Answer Trigger',
  TIMEOUT_TRIGGER_NAME: 'Timeout Trigger',
  TRANSITION_TRIGGER_NAME: 'Transition Trigger',
  WRONG_ANSWER_TRIGGER_NAME: 'Wrong Answer Trigger',
  DEFAULT_TRIGGER_NAME: 'Default Trigger',
  pending: 'Pending',
  resolved: 'Resolved',
  approved: 'Approved',
  'We will send you a confirmation e-mail.': 'We will send you a confirmation e-mail.',
  'Account activation': 'Account activation',
  'We were unable to confirm your account, please contact support.': 'We were unable to confirm your account, please contact support.'
}
